// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"549":"8593ecc9","895":"e59b8ddb","930":"c9f99704"}[chunkId] + ".css";
};